import { CheckoutResponse } from "@/fetch/getCheckoutResponse";
import { baseApi } from "@/store/baseApi";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import Cookies from "js-cookie";

export const checkoutApi = baseApi
  .enhanceEndpoints({
    addTagTypes: ["SHOPPING_CART"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      placeOrder: builder.mutation<CheckoutResponse | string | null, CheckoutResponse>({
        query: (checkoutRequest) => ({
          url: "/neo/checkout/placeOrder",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            gtm_preview_header: Cookies.get("gtm_preview_header"),
            _ga: Cookies.get("_ga"),
          },
          body: JSON.stringify(checkoutRequest),
        }),
        transformResponse: async (response: CheckoutResponse) => {
          return response;
        },
        transformErrorResponse: async (error: FetchBaseQueryError) => {
          if (error.status === 500 || error.status === 422) {
            // Handle 500 and 422 error
            if (error.data != null) {
              const payload = error.data;
              const errorItem = Array.isArray(payload) && payload[0];
              return errorItem?.message || null;
            }
          } else if (error.status === 401) {
            return "UNATHORIZED";
          } else {
            return null;
          }
          //return getServerError(error);
        },
        invalidatesTags: (result) => (result ? [{ type: "SHOPPING_CART" }] : []), // Invalidate SHOPPING_CART tag only on success
      }),
    }),
  });

export const { usePlaceOrderMutation } = checkoutApi;
export const { placeOrder } = checkoutApi.endpoints;
